import { Pipe, PipeTransform } from '@angular/core';
import { Skill } from '@lib/shared-interface-skill';

@Pipe({
    standalone: true,
    name: 'libSortResourceSkills',
})
export class SortResourceSkillsPipe implements PipeTransform {
    public transform<InputType extends Skill>(skills: InputType[] | undefined): InputType[] {
        if (skills == undefined) {
            return [] as InputType[];
        }
        return [...skills].sort((skillA: InputType, skillB: InputType) => {
            return (skillA.group?.sortOrder ?? 0) - (skillB.group?.sortOrder ?? 0);
        });
    }
}
